import { render, staticRenderFns } from "./DeletedSites.vue?vue&type=template&id=6c3626c0&"
import script from "./DeletedSites.vue?vue&type=script&lang=js&"
export * from "./DeletedSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports